import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign, BarChart3, FileText, Calculator } from 'lucide-react';

export const MobileFinance: React.FC = () => {
  return (
    <div className="p-4 space-y-4">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">Finance</h1>
        <p className="text-muted-foreground">Financial management and reporting</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <DollarSign className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Revenue</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <BarChart3 className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Analytics</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <FileText className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">Reports</p>
          </CardContent>
        </Card>

        <Card className="bg-card/50 border-border hover:bg-card/70 transition-colors">
          <CardContent className="p-4 text-center">
            <Calculator className="h-8 w-8 mx-auto mb-2 text-primary" />
            <p className="text-sm text-foreground font-medium">QuickBooks</p>
          </CardContent>
        </Card>
      </div>

      <div className="mt-6">
        <Card className="bg-card/30 border-border">
          <CardHeader>
            <CardTitle className="text-foreground text-lg">Financial Summary</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">Financial data will be displayed here</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};